// Fuzzball Quiz - Klaviyo Event API Integration
// Uses Klaviyo's track() API to record quiz submissions as events

class KlaviyoEventSubmitter {
  constructor() {
    this.submissionInProgress = false;
  }

  async submitQuizData(submissionData) {
    if (this.submissionInProgress) {
      return { success: false, error: 'Submission in progress' };
    }

    this.submissionInProgress = true;

    // Log submission data

    try {
      // Check if klaviyo object exists
      if (typeof klaviyo === 'undefined') {
        throw new Error('Klaviyo JavaScript API not loaded. Make sure Klaviyo tracking script is installed.');
      }

      const catCount = submissionData.catCount || 1;

      // First, identify the user with basic info
      const identifyData = {
        email: submissionData.customer_email,
        first_name: submissionData.customer_name.split(' ')[0],
        last_name: submissionData.customer_name.split(' ').slice(1).join(' ') || ''
      };

      // Build the event data with customer info first
      const eventData = {
        // Customer info (Step 6)
        customer_name: submissionData.customer_name,
        customer_email: submissionData.customer_email,
        total_cats: catCount
      };

      // Add each cat's data in quiz step order
      for (let i = 0; i < catCount; i++) {
        const catData = submissionData[`cat${i + 1}`];
        if (catData) {
          // Step 1: Name
          eventData[`cat_${i + 1}_name`] = catData.fuzzballer_name || '';

          // Step 2: Breed
          eventData[`cat_${i + 1}_breed`] = catData.breed || '';

          // Age & Birth Month
          eventData[`cat_${i + 1}_age`] = catData.age_range || '';
          eventData[`cat_${i + 1}_birth_month`] = catData.birth_month || '';

          // Health Concerns
          eventData[`cat_${i + 1}_has_health_concerns`] = catData.health_concerns_exists === 'Yes' ? 'true' : 'false';
          eventData[`cat_${i + 1}_health_details`] = catData.health_concerns || '';
          
          // Step 6: Food Preference
          eventData[`cat_${i + 1}_food_preference`] = catData.wet_dry_preference || '';
          eventData[`cat_${i + 1}_cans_per_day`] = catData.cans_per_day || '';

          // Lifestyle
          eventData[`cat_${i + 1}_lifestyle`] = catData.lifestyle || '';
          
          // Step 8: Food Dislikes
          eventData[`cat_${i + 1}_food_dislikes`] = (catData.disliked_flavors || []).join('|') || 'none';
          
        }
      }

      // Log the complete data being sent

      // Submit to Klaviyo using identify and track APIs
      await this.submitToKlaviyo(identifyData, eventData);

      
      return { success: true };

    } catch (error) {
      return { success: false, error: error.message };
    } finally {
      this.submissionInProgress = false;
    }
  }

  async submitToKlaviyo(identifyData, eventData) {
    return new Promise((resolve, reject) => {
      try {
        // First identify the user
        
        klaviyo.identify(identifyData, function() {
          
          // Then track the quiz completion event with all cat data
          
          klaviyo.track('Quiz Submitted', eventData);
          
          
          resolve();
        });

        // Fallback timeout in case callback doesn't fire
        setTimeout(() => {
          resolve();
        }, 2000);

      } catch (error) {
        reject(error);
      }
    });
  }

}

// Export for use in quiz controller
window.KlaviyoEventSubmitter = KlaviyoEventSubmitter;
window.KlaviyoAPISubmitter = KlaviyoEventSubmitter; // Keep backward compatibility

// Debug helper for manual testing
window.debugKlaviyoEvent = function() {
  const submitter = new KlaviyoEventSubmitter();
  const testData = {
    customer_name: 'Test User',
    customer_email: 'test@example.com',
    catCount: 2,
    cat1: {
      fuzzballer_name: 'Fluffy',
      age_range: '2 years old',
      birth_month: 'January',
      breed: 'Persian',
      wet_dry_preference: 'A mix of both',
      health_concerns_exists: 'No',
      health_concerns: '',
      lifestyle: 'Indoor',
      disliked_flavors: ['Fish']
    },
    cat2: {
      fuzzballer_name: 'Mittens',
      age_range: '6 months old',
      birth_month: 'June',
      breed: 'Tabby',
      wet_dry_preference: 'Wet food only',
      health_concerns_exists: 'Yes',
      health_concerns: 'Sensitive stomach',
      lifestyle: 'Indoor',
      disliked_flavors: ['Beef', 'Turkey']
    }
  };
  
  return submitter.submitQuizData(testData);
};

// Check if Klaviyo is loaded
window.checkKlaviyoLoaded = function() {
  if (typeof klaviyo !== 'undefined') {
    return true;
  } else {
    return false;
  }
};

